import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import ProgressBar from 'components/Widgets/ProgressBar';
import IconWithText from 'components/Widgets/IconWithText';
import SubmitButton from 'components/Widgets/SubmitButton';
import useTimeZones from 'components/Common/TimeZones/Hooks/useTimeZones';

import Actions from './Actions';

export default function PersonalInformation({ affiliate, nextUrl, prevUrl }) {
  const formSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    timeZone: Yup.string().typeError('Time Zone is required'),
    email: Yup.string().required('Email is required'),
    phone: Yup.string().required('Mobile Phone is required'),
  });

  const { timeZones } = useTimeZones();

  const onSave = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      affiliate.id,
      {
        first_name: values.firstName,
        last_name: values.lastName,
        time_zone: values.timeZone,
        phone: values.phone,
      },
      () => {
        setSubmitting(false);
        Actions.goToPage(nextUrl);
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <div className="content">
      <section>
        <Row>
          <Col md={8}>
            <h1 className="mb-3">Tell us about yourself</h1>

            <IconWithText
              iconClassName="onboarding-personal-data-icon big-icon bg-secondary"
            >
              <h5>Part 1: Personal information</h5>
              Please confirm your user information.
            </IconWithText>
          </Col>

          <Col md={4} className="mt-3 mt-md-0">
            <ProgressBar now={25} />
          </Col>
        </Row>
      </section>

      <Formik
        validationSchema={formSchema}
        initialValues={{
          firstName: affiliate.attributes.first_name,
          lastName: affiliate.attributes.last_name,
          timeZone: affiliate.attributes.time_zone,
          email: affiliate.attributes.email,
          phone: affiliate.attributes.phone,
        }}
        onSubmit={onSave}
      >
        {({ isSubmitting }) => (
          <FormikForm className="form-with-counter" noValidate="">
            <section className="border-top border-light">
              <Row>
                <Col md={{ span: 8, offset: 2 }}>
                  <HorizontalTextField name="firstName" label="First Name" required />

                  <HorizontalTextField name="lastName" label="Last Name" required />

                  <HorizontalSelectField
                    className="select-counter-form"
                    name="timeZone"
                    label="Time Zone"
                    placeholder={timeZones === null ? 'Loading...' : 'Select Time Zone'}
                    options={timeZones === null ? [] : timeZones}
                    required
                  />

                  <HorizontalTextField name="email" disabled label="Email" required />

                  <HorizontalTextField name="phone" label="Mobile Phone" required />
                </Col>
              </Row>
            </section>

            <footer className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                disabled={isSubmitting}
                onClick={() => { Actions.goToPage(prevUrl); }}
              >
                Previous
              </Button>

              <SubmitButton loading={isSubmitting}>
                Next
              </SubmitButton>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
}

PersonalInformation.propTypes = {
  affiliate: PropTypes.object.isRequired,
  nextUrl: PropTypes.string.isRequired,
  prevUrl: PropTypes.string.isRequired,
};
